

































































































































































































































































import LatestEntriesCardEmpty from "@/components/cards/LatestEntriesCardEmpty.vue";
import TemplateCard from "@/components/template/TemplateCard.vue";
import TemplateDialog from "@/components/template/TemplateDialog.vue";
import TemplateEditor from "@/components/template/TemplateEditor.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MDetailViewGrid from "@/components/utility/mmmint/MDetailViewGrid.vue";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import RefsSelect from "@/components/utility/RefsSelect.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import TimelineCard from "@/components/utility/TimelineItem.vue";
import ViewedPreview from "@/components/utility/ViewedPreview.vue";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { MessageFolderEnum } from "@/lib/enum/message-folder.enum";
import { detailedDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { isMobile } from "@/lib/utility/isMobile";
import { avatar } from "@/lib/utility/mail-helper";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IPartnerMessage, messageFolderIconMap } from "@/models/partner-message.entity";
import { IReference } from "@/models/reference.entity";
import { TimeStampEntity } from "@/models/timestampEntity";
import { ResourceEnum, BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { debounce } from "debounce";
import { Component, Prop } from "vue-property-decorator";
import PartnerMessageDetailAttachDialog from "@/components/partner/PartnerMessageDetailAttachDialog.vue";
import PartnerMessageDetailAttachmentRow from "@/components/partner/PartnerMessageDetailAttachmentRow.vue";
import PartnerMessageDetailReportRefs from "@/components/partner/PartnerMessageDetailReportRefs.vue";
import CostCreateDialog from "@/components/cost/CostCreateDialog.vue";
import { ISignDocument } from "@/models/sign-document.entity";
import { ICost, Cost } from "@/models/cost.entity";
import TicketCreateDialog from "@/components/project/TicketCreateDialog.vue";
import { ITicket, Ticket } from "@/models/ticket.entity";
import CostSideCard from "@/components/cost/CostSideCard.vue";
import { TicketModule } from "@/store/modules/ticket.store";
import { CostModule } from "@/store/modules/cost.store";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import TicketSideCard from "../ticket/TicketSideCard.vue";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ConfigModule } from "@/store/modules/config";
import { AppContextEnum } from "@/lib/enum/appContext.enum";
import { Report } from "@/models/report.entity";
import { ReportGoToHelper } from "@/lib/utility/report.go-to-helper";
import AEiLoading from "../utility/AEiLoading.vue";
import MActionList from "../utility/mmmint/MActionList.vue";
import personService from "@/services/mrfiktiv/services/person.service";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { IPerson, Person } from "@/models/person.entity";
import { Company, ICompany } from "@/models/company.entity";
import companyService from "@/services/mrfiktiv/services/companyService";
import RefsCompany from "../utility/RefsCompany.vue";
import RefsPerson from "../utility/RefsPerson.vue";
import { PersonGoToHelper } from "@/lib/utility/person.go-to-helper";
import { CompanyGoToHelper } from "@/lib/utility/company.go-to-helper";

@Component({
  name: "PartnerMessageDetail",
  components: {
    MHeader,
    TemplateEditor,
    TimelineCard,
    TemplateCard,
    TemplateDialog,
    LatestEntriesCardEmpty,
    ConfirmActionDialog,
    MDetailViewGrid,
    SelectAssignees,
    ViewedPreview,
    RefsSelect,
    PartnerMessageDetailReportRefs,
    PartnerMessageDetailAttachmentRow,
    PartnerMessageDetailAttachDialog,
    CostCreateDialog,
    TicketCreateDialog,
    CostSideCard,
    TicketSideCard,
    AEiLoading,
    MActionList,
    RefsPerson,
    RefsCompany
  }
})
export default class PartnerMessageDetail extends PermissionMixin {
  @Prop({ default: false })
  loading!: boolean;

  @Prop()
  value?: IPartnerMessage;

  isMounting = false;
  unMarkMenu = false;

  isArchiveDialogOpen = false;
  isAiReportDialogOpen = false;
  isMoveDialogOpen = false;
  isCostCreateDialogActive = false;
  isTicketCreateDialogActive = false;

  isArchiveLoading = false;
  isMarkUnreadLoading = false;
  isAiReportLoading = false;
  isLoadingRefs = false;
  isMoveLoading = false;

  selectedTicket: ITicket | null = null;
  selectedCost: ICost | null = null;

  persons: IPerson[] = [];
  companies: ICompany[] = [];

  get ticketCreateRefs(): IReference[] {
    const refs: IReference[] = [];

    if (!this.value) {
      return refs;
    }

    if (this.value?.attachments) {
      for (const attachment of this.value?.attachments ?? []) {
        if (attachment.ref?.refType === ResourceEnum.DOCUMENT) {
          refs.push(attachment.ref);
        }
      }
    }
    refs.push({ refType: ResourceEnum.MESSAGE, refId: this.value?.id });
    if (this.value?.refs) {
      for (const ref of this.value.refs) {
        if (ref.refType === ResourceEnum.REPORT) {
          refs.push(ref);
        }
      }
    }

    return refs;
  }

  get reportReferences(): IReference[] {
    return this.value?.refs?.filter(r => r.refType === ResourceEnum.REPORT) ?? [];
  }

  get editNonReportReferences(): IReference[] {
    return this.value?.refs?.filter(r => r.refType !== ResourceEnum.REPORT) ?? [];
  }

  set editNonReportReferences(v: IReference[]) {
    if (!this.value) return;
    this.value.refs = [...v, ...this.reportReferences];
  }

  get isTouch() {
    return isMobile();
  }

  get folderOptions() {
    return Object.values(MessageFolderEnum);
  }

  get messageFolderIconMap() {
    return messageFolderIconMap;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (!this.$route.params.messageId) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        exec: () => this.value?.goToDetail(this.$router)
      });
    }

    actions.push({
      text: $t("common.verbs.reply"),
      key: "Reply",
      icon: "mdi-reply-outline",
      exec: () => (this.$refs.templateDialog as TemplateDialog)?.show()
    });

    if (this.value?.viewed.length) {
      actions.push({
        text: $t("components.PartnerMessageDetail.markUnread"),
        key: "unread",
        icon: "mdi-check-all",
        exec: () => this.markUnread()
      });
    }

    actions.push({
      text: $t("message.attachToReport"),
      key: "Attach",
      icon: "mdi-car-outline",
      exec: () => (this.$refs.attachDialog as PartnerMessageDetailAttachDialog)?.open()
    });

    if (ConfigModule.appContext === AppContextEnum.REPORT_PORTAL && this.can(ActionEnum.CREATE, ResourceEnum.AI)) {
      actions.push({
        text: $t("report.generateWithAi"),
        key: "ai-report-creation",
        icon: "mdi-creation",
        exec: () => (this.isAiReportDialogOpen = true)
      });
    }

    if (this.can(ActionEnum.CREATE, ResourceEnum.TICKET)) {
      actions.push({
        key: "createTicket",
        icon: "mdi-ticket-outline",
        text: this.$t("project.ticket.createTicket").toString(),
        color: "",
        exec: () => (this.$refs.ticketCreateDialog as TicketCreateDialog).startDialog()
      });
    }

    if (this.can(ActionEnum.CREATE, ResourceEnum.COST)) {
      actions.push({
        key: "createCost",
        icon: "mdi-cash-multiple",
        text: this.$t("cost.createCost").toString(),
        color: "",
        exec: () => this.openCreateCostDialog()
      });
    }

    if (this.value?.url) {
      actions.push({
        text: $t("common.verbs.download"),
        key: "Download",
        icon: "mdi-download",
        exec: () => this.value?.download()
      });
    }

    actions.push({
      text: $t("common.verbs.move"),
      key: "move",
      icon: "mdi-inbox-multiple",
      exec: () => (this.isMoveDialogOpen = true)
    });

    if (this.value?.folder !== MessageFolderEnum.ARCHIVE) {
      actions.push({
        text: $t("common.verbs.archive"),
        key: "Archive",
        icon: "mdi-inbox",
        exec: () => (this.isArchiveDialogOpen = true)
      });
    }

    return actions;
  }

  get bottomActions() {
    const actions: IAction[] = [];

    if (!this.value?.refs?.find(r => r.refType === ResourceEnum.REPORT)) {
      actions.push({
        text: $t("message.attachToReport"),
        key: "Attach",
        icon: "mdi-car-outline",
        exec: () => (this.$refs.attachDialog as PartnerMessageDetailAttachDialog)?.open()
      });

      if (ConfigModule.appContext === AppContextEnum.REPORT_PORTAL && this.can(ActionEnum.CREATE, ResourceEnum.AI)) {
        actions.push({
          text: $t("report.generateWithAi"),
          key: "ai-report-creation",
          icon: "mdi-creation",
          exec: () => (this.isAiReportDialogOpen = true)
        });
      }
    }

    if (this.can(ActionEnum.CREATE, ResourceEnum.TICKET)) {
      actions.push({
        key: "createTicket",
        icon: "mdi-ticket-outline",
        text: this.$t("project.ticket.createTicket").toString(),
        color: "",
        exec: () => (this.$refs.ticketCreateDialog as TicketCreateDialog).startDialog()
      });
    }

    if (this.value?.viewed.length) {
      actions.push({
        text: $t("components.PartnerMessageDetail.markUnread"),
        key: "unread",
        icon: "mdi-check-all",
        exec: () => this.markUnread()
      });
    }

    actions.push({
      text: $t("common.verbs.move"),
      key: "move",
      icon: "mdi-inbox-multiple",
      exec: () => (this.isMoveDialogOpen = true)
    });

    if (this.value?.folder !== MessageFolderEnum.ARCHIVE) {
      actions.push({
        text: $t("common.verbs.archive"),
        key: "Archive",
        icon: "mdi-inbox",
        exec: () => (this.isArchiveDialogOpen = true)
      });
    }

    return actions;
  }

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];
    const isDetailView = this.$route.params.messageId;

    breadCrumbs.push({
      text: $t("common.nouns.inboxes"),
      to: { name: "PartnerMessageInboxList", params: { partnerId: this.partner.id } },
      exact: true
    });

    const inbox = PartnerModule.partner.settings?.inboxes?.find(inbox => inbox.identifier === this.value?.to);
    if (inbox) {
      breadCrumbs.push({
        text: inbox.identifier,
        to: {
          name: "PartnerMessageInbox",
          params: { partnerId: this.value?.partnerId ?? "", inboxId: this.value?.to ?? "" },
          query: { folder: this.value?.folder.toString() ?? "" }
        },
        exact: true,
        disabled: Boolean(isDetailView)
      });
    }

    if (this.value?.folder) {
      breadCrumbs.push({
        text: $t("MessageFolderEnum." + this.value?.folder),
        to: { name: "PartnerMessageDetail" },
        exact: true,
        disabled: true
      });
    } else {
      breadCrumbs.push({
        text: $t("common.nouns.detail"),
        to: { name: "PartnerMessageDetail" },
        exact: true,
        disabled: true
      });
    }
    return breadCrumbs;
  }

  get chips(): IAction[] | undefined {
    return undefined;
  }

  /**
   * E.g. "user xy from mrfiktiv"
   */
  get fromMail() {
    let fromMail = PartnerModule.partner.companyName;
    let fromUser = "";

    if (this.value?.folder === MessageFolderEnum.OUTBOX) {
      return this.value?.to;
    }

    if (this.value?.from) {
      fromMail = this.value.from;
    }

    if (this.userNameForId) {
      fromUser = this.$t("components.PartnerMessageDetail.toAlt", { mail: this.userNameForId }).toString();
    }

    return fromUser + fromMail;
  }

  get date() {
    if ((this.value?.timestamp as TimeStampEntity).created) {
      const locale = this.$t("utility.toLocalDateString").toString() || "de-de";

      return detailedDate((this.value?.timestamp as TimeStampEntity).created, locale);
    }
    return "";
  }

  get partner() {
    return PartnerModule.partner;
  }

  get from() {
    return this.partner;
  }

  get to(): string[] {
    if (!this.value?.to) {
      return [];
    }
    return [this.value?.to];
  }

  get userNameForId() {
    if (this.value?.userId === undefined) {
      return "";
    }

    const user = PartnerUserModule.maps.id.get(this.value.userId)[0];
    if (!user) {
      return "";
    }

    return user.firstName + " " + user.lastName;
  }

  async openCreateCostDialog() {
    const message = this.value;
    if (!message) {
      return;
    }
    const costCreateDialog = this.$refs.costCreateDialog as CostCreateDialog;
    if (!costCreateDialog) {
      throw new Error("No CostCreateDialog");
    }
    costCreateDialog.isLoading = true;
    const documents = ((
      await Promise.all(
        this.value?.attachments.map(async attachment => {
          if (!attachment.isPdf) return undefined;
          return attachment.getReference(message);
        }) ?? []
      )
    ).filter(document => !!document) ?? []) as ISignDocument[];
    costCreateDialog.show();
    costCreateDialog.cost.files.push(...documents.map(document => document.id));
    await costCreateDialog.onCreatedDocument(...documents);
    costCreateDialog.isLoading = false;
  }

  getAvatar(mail: string) {
    return avatar(mail);
  }

  abortArchive() {
    this.isArchiveDialogOpen = false;
  }

  async archive() {
    try {
      if (!this.value) {
        return;
      }
      this.isArchiveLoading = true;
      await this.value.archive();
    } catch (e) {
      handleError(e);
    } finally {
      this.isArchiveDialogOpen = false;
      this.isArchiveLoading = false;
    }
  }

  abortAiReport() {
    this.isAiReportDialogOpen = false;
  }

  async generateAiReport() {
    try {
      if (!this.value) {
        return;
      }
      this.isAiReportLoading = true;
      const { isReportMessage, report } = await new Report({
        partnerId: this.value.partnerId
      }).generateFromMessageWithAi(this.value.id);

      if (report) {
        return new ReportGoToHelper(this.$router).goToReportDetail({
          partnerId: this.value.partnerId,
          reportId: report.id,
          newTab: false
        });
      }

      if (!isReportMessage) {
        this.$toast.warning($t("report.generateWithAiFailed"));
      }

      this.isAiReportDialogOpen = false;
    } catch (e) {
      handleError(e);
    } finally {
      this.isAiReportLoading = false;
    }
  }

  async markUnread() {
    if (!this.value || this.isMarkUnreadLoading) {
      return;
    }

    this.isMarkUnreadLoading = true;
    await this.value.markUnread().catch(handleError);
    this.isMarkUnreadLoading = false;
    this.unMarkMenu = false;
  }

  async onAssigneesUpdate(assignees: []) {
    if (!this.value) return;

    await this.value.updatePartial({ assignees });
  }

  async onAssigneesAdded(assignees: string[]) {
    if (!this.value) return;

    await this.value.createAssigneeActivity(ActivityTypeEnum.CREATE_ASSIGNEE, assignees);
  }

  async onAssigneesRemoved(assignees: string[]) {
    if (!this.value) return;

    await this.value.createAssigneeActivity(ActivityTypeEnum.DELETE_ASSIGNEE, assignees);
  }

  async updateNonReportRefs(refs?: IReference[]) {
    if (!this.value) return;
    if (refs) {
      this.value.refs?.splice(0);
      this.value.refs?.push(...(refs ?? []));
    }

    await this.debounceSaveRefs();
  }

  debounceSaveRefs = debounce(this.saveRefs, 500);
  private async saveRefs() {
    if (!this.value) return;
    this.isLoadingRefs = true;
    await this.value
      .updatePartial({
        refs: this.value?.refs
      })
      .catch(handleError);
    this.isLoadingRefs = false;
  }

  async setNewFolder(folder: MessageFolderEnum) {
    if (!this.value) return;

    this.isMoveLoading = true;
    await this.value
      .updatePartial({
        folder: folder
      })
      .catch(handleError);
    this.isMoveLoading = false;
  }

  async onCostCreated(cost: ICost) {
    if (!this.value) return;
    this.isLoadingRefs = true;
    await this.value
      .updatePartial({
        refs: [
          ...(this.value.refs ?? []),
          {
            refId: cost.id,
            refType: ResourceEnum.COST
          }
        ]
      })
      .catch(e => this.$log.error(e));
    this.isLoadingRefs = false;
  }

  async onTicketCreated(ticket: ITicket) {
    if (!this.value) return;
    this.isLoadingRefs = true;
    await this.value
      .updatePartial({
        refs: [
          ...(this.value.refs ?? []),
          {
            refId: ticket.id,
            refType: ResourceEnum.TICKET
          }
        ]
      })
      .catch(e => this.$log.error(e));
    this.isLoadingRefs = false;
  }

  async openSideCard(ref: IReference) {
    if (ref.refType === BackendResourceEnum.TICKET) {
      this.selectedTicket = null;
      const ticket =
        TicketModule.maps.id.get(ref.refId)[0] ??
        (await new Ticket({ id: ref.refId, partnerId: this.value?.partnerId }).fetch().catch(handleError));
      this.$nextTick(() => {
        this.selectedTicket = ticket;
      });
    } else if (ref.refType === BackendResourceEnum.COST) {
      this.selectedCost = null;
      const cost =
        CostModule.maps.id.get(ref.refId)[0] ??
        (await new Cost({ id: ref.refId, partnerId: this.value?.partnerId }).fetch().catch(handleError));
      this.$nextTick(() => {
        this.selectedCost = cost;
      });
    }
  }

  onActionClicked(action: IAction) {
    action?.exec?.();
  }

  gotToPerson(p: IPerson) {
    new PersonGoToHelper(this.$router).goToPersonDetail({ personId: p.id, partnerId: p.partnerId, newTab: true });
  }

  goToCompany(p: ICompany) {
    new CompanyGoToHelper(this.$router).goToCompanyDetail({ companyId: p.id, partnerId: p.partnerId, newTab: true });
  }

  async mounted() {
    await personService
      .get({
        partnerId: this.partner.id,
        filter: [
          new PageFilterElement({
            key: "emails.email",
            operation: "$eq",
            value: this.value?.from
          })
        ]
      })
      .then(res => (this.persons = res.data?.map(r => new Person(r)) ?? []));

    await companyService
      .get({
        partnerId: this.partner.id,
        filter: [
          new PageFilterElement({
            key: "contact.email",
            operation: "$eq",
            value: this.value?.from
          })
        ]
      })
      .then(res => (this.companies = res.data?.map(r => new Company(r)) ?? []));
  }
}
